@if (menuItems()) {
  <ul class="navbar-nav flex-grow">
    @for (item of menuItems(); track item) {
      <li [routerLinkActive]="['link-active']">
        <div class="arrow-up pointer" [hidden]="!expandedItem || !item.expanded"></div>
        <a class="nav-link text-dark mx-2" (click)="onMainItemClick(item)" href="javascript:;">{{item.name | uppercase}}</a>
      </li>
    }
    <li>
      <a class="scl-connect-link mx-2" href="https://connect.securechoicelending.com" target="_blank">
        <span>SCL Connect</span>
      </a>
    </li>
  </ul>

  @for (item of menuItems(); track item) {
    @if (expandedItem && item.name == expandedItem.name && expandedItem.expanded) {
      <ng-container [ngTemplateOutlet]="expandTmpl"
      [ngTemplateOutletContext]="{mainItem: item, subItems: item.subItems}"></ng-container>
    }
  }
}

<ng-template #expandTmpl let-mainItem="mainItem" let-subItems="subItems">
  <div class="container-fluid expand-secondary-nav">
    <div class="container d-block">
      <div class="row">
        <div class="col-lg-4 border-right py-3 px-4" style="order: 1">
          @for (item of subItems; track item.name) {
            @if (item.col == 1) {
              <div class="py-3 d-flex sub-nav-item">
                <div class="flex-basis">
                  <img [src]="item.imgSrc" class="img-fluid nav-img">
                </div>
                <div>
                  <h4>
                    <a [routerLink]="item.navCommands" (click)="onSubItemClick(mainItem)" class="nav-link-expand">
                      {{item.name | uppercase}}
                    </a>
                  </h4>
                  <p>{{item.description}}</p>
                </div>
              </div>
            }
          }
        </div>
        <div class="col-lg-4 border-right py-3 px-4" style="order: 2">
          @for (item of subItems; track item.name) {
            @if (item.col == 2) {
              <div class="d-flex py-3 sub-nav-item">
                <div class="flex-basis">
                  <img [src]="item.imgSrc" class="img-fluid nav-img">
                </div>
                <div>
                  <h4>
                    <a [routerLink]="item.navCommands" (click)="onSubItemClick(mainItem)" class="nav-link-expand">
                      {{item.name | uppercase}}
                    </a>
                  </h4>
                  <p>{{item.description}}</p>
                </div>
              </div>
            }
          }
        </div>
        <div class="col-lg-4 py-3 px-4" style="order: 3">
          @for (item of subItems; track item.name) {
            @if (item.col == 3) {
              <div class="d-flex py-3 sub-nav-item">
                <div class="flex-basis">
                  <img [src]="item.imgSrc" class="img-fluid nav-img">
                </div>
                <div>
                  <h4>
                    @if (!item.externalLink) {
                      <a [routerLink]="item.navCommands" (click)="onSubItemClick(mainItem)" class="nav-link-expand">
                        {{item.name | uppercase}}
                      </a>
                    } @else {
                      <a [href]="item.externalLink" target="_blank" (click)="onSubItemClick(mainItem)"
                        class="nav-link-expand">
                        {{item.name | uppercase}}
                      </a>
                    }
                  </h4>
                  <p>{{item.description}}</p>
                </div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>
